<ng-container [formGroup]="formGroup">
    <lib-datepicker class="mr-3 datepicker size-s" label="Start Date" formControlName="minimum" inputDatetimeFormat="yyyy-MM-dd"> </lib-datepicker>
    <lib-datepicker class="datepicker size-s" label="End Date" formControlName="maximum" inputDatetimeFormat="yyyy-MM-dd"> </lib-datepicker>
</ng-container>
